import { render, staticRenderFns } from "./MoreCard.vue?vue&type=template&id=265d6b5e&"
import script from "./MoreCard.vue?vue&type=script&lang=js&"
export * from "./MoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports